import createComponent from '@carvana/merch-components/createComponent';
import Image from '@/common/Image';
import dealershipFamilyMap from '~/constants/dealership/dealershipFamilyMap';
import { appAssetsCdnUrl } from '~/constants/environment';
import {
  useDealershipId,
  useStaticContext
} from '~/context/dealership/StaticContext';

const Copy = createComponent('p', {
  className:
    'w-[137px] self-center text-left text-text-inverse t-heading-sm sm:w-[260px] sm:t-heading-md lg:w-[388px] xl:t-heading-2xl'
});

const Container = createComponent('div', {
  className:
    'relative mb-2xl flex h-[108px] max-w-full flex-col items-center justify-center overflow-hidden rounded-lg bg-background-muted-strong sm:h-[100px] xl:h-[168px]'
});

const defaultCopy = 'Free delivery and same-day pickup may be available';
const inventoryAvailabilityCopy: Record<string, string> = {
  'bos-cdjr-new': 'Coming soon. Available March 10'
};

export default function Banner() {
  const dealershipId = useDealershipId();
  const { hasInventory } = useStaticContext();

  const dealershipFamily = dealershipId
    ? dealershipFamilyMap[dealershipId]
    : null;

  const availabilityCopy =
    hasInventory || !dealershipId
      ? null
      : inventoryAvailabilityCopy[dealershipId];
  const copy = availabilityCopy ?? defaultCopy;

  return (
    <Container>
      <Image
        src={`${appAssetsCdnUrl}/images/dealership/banner-left-mobile.png`}
        alt={copy}
        className="absolute left-0 top-0 h-full object-contain"
        wrapperClassName="sm:hidden lg:hidden w-full"
        loading="lazy"
        optimize={{
          format: 'auto',
          optimize: 'high',
          quality: 90
        }}
      />

      <Image
        src={`${appAssetsCdnUrl}/images/dealership/${dealershipFamily}/banner-right-mobile.png`}
        alt={copy}
        className="absolute right-0 top-0 h-full object-contain"
        wrapperClassName="sm:hidden lg:hidden w-full"
        loading="lazy"
        optimize={{
          format: 'auto',
          optimize: 'high',
          quality: 90
        }}
      />

      <Image
        src={`${appAssetsCdnUrl}/images/dealership/banner-left-desktop.png`}
        alt={copy}
        className="absolute left-0 top-0 h-full object-contain"
        wrapperClassName="hidden sm:block w-full"
        loading="lazy"
        optimize={{
          format: 'auto',
          optimize: 'high',
          quality: 90
        }}
      />

      <Image
        src={`${appAssetsCdnUrl}/images/dealership/${dealershipFamily}/banner-right-desktop.png`}
        alt={copy}
        className="absolute right-0 top-0 h-full object-contain"
        wrapperClassName="hidden sm:block w-full"
        loading="lazy"
        optimize={{
          format: 'auto',
          optimize: 'high',
          quality: 90
        }}
      />

      <Copy className={availabilityCopy ? 'text-center' : undefined}>
        {copy}
      </Copy>
    </Container>
  );
}
